export default "<span class=\"badge badge-primary\">{{ listOfItems.length | countItems : listOfItems : itemsType }}</span>"